import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { pagesRoutes } from '../../pages/pages-routing.module';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: pagesRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {}
